__webpack_require__.p = "/nft-preview-card/";